<template>
<div class="ti d-flex">
  <div class="d-flex-left">
    <erp-project @node-click="nodeClick"></erp-project>
  </div>
  <div class="d-flex-right" v-if="dades.pindex_id">
    <Row class="loading" :style="loading==true ? 'z-index:10000' : 'display:none'">
      <Col class="demo-spin-col" span="8">
        <Spin fix>
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>加载中</div>
        </Spin>
      </Col>
    </Row>
    <div>
      <el-button size="mini" type="primary text2"  @click="modals" v-if="ERP.isPermission(4004006001)">绑定收费项</el-button>
      <el-input size="mini" class="search" placeholder="请输入搜索名称" v-model="search" clearable></el-input>
      <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
    </div>
    <div>位置：{{company_name}}-{{jname}}-{{name}}（生成进度更新，请点击搜索查看最新状态）</div>
    <v-divider></v-divider>
    <v-simple-table :height="__TABLE_HEIGHT__">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">ID</th>
          <th class="text-left">缴费名称</th>
          <th class="text-left">项目</th>
          <!-- <th class="text-left">类型</th> -->
          <th class="text-left">备注</th>
          <th class="text-left">创建人</th>
          <th class="text-left">修改人</th>
          <th class="text-left">生成进度</th>
          <th class="text-left">添加日期</th>
          <th class="text-left">修改日期</th>
          <th class="text-left">操作</th>
        </tr>
        </thead>
        <tbody>
        <tr class="text1" v-for="item in desserts" :key="item.id">
          <td >{{item.id}}</td>
          <td >{{item.name}}</td>
          <td >{{name}}</td>
          <!-- <td >{{item.type_name}}</td> -->
          <td >{{item.remarks}}</td>
          <td >{{item.founder}}</td>
          <td >{{item.reviser}}</td>
          <td >
            <!-- 生成进度 -->
            <span v-if="item.progress_e == 0">--</span>
            <span v-if="item.progress_e<item.progress_s">{{item.progress_s}}/{{item.progress_e}}</span>
            <span v-if="item.progress_e>item.progress_s">{{item.progress_s}}/{{item.progress_e}}</span>
            <span v-if="item.progress_s==item.progress_e && item.progress_e>0">完成</span></td>
          <td >{{item.s_date}}</td>
          <td >{{item.e_date}}</td>
          <td class="cdj_td">
            <div v-if="ERP.isPermission(4004006002) && item.progress_s==item.progress_e">
              <div  style="color: #1867c0;cursor: pointer;" @click="shengc( item.id )">生成账单</div>
            </div>
            <div v-if="ERP.isPermission(4004006003)">
              <div style="color: #1867c0;margin-left: 5px;cursor: pointer;" @click="xiugai( item.id )">修改</div>
            </div>
            <div v-if="ERP.isPermission(4004006004)">
              <div  style="color: red;margin-left: 5px;cursor: pointer;" @click="del( item.id )">删除</div>
            </div>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <div class="pages" v-if="desserts">
      <Page :total="total" :page-size="page" @on-change="change"  show-total />
    </div>
    <div class="zhanwu" v-else>没有数据</div>
    <Modal
      v-model="modal1"
      :ok-text="anxiu"
      :loading="loadingModal"
      width="600"
      title="编辑收费项"
      @on-ok="ok">
      <el-form style="height: 600px;overflow: auto;">
        <div>
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>缴费名称</span>
            <el-input class="cdj_input"  placeholder="请输入内容" v-model="dades.name"></el-input>
          </div>
          <!-- <div class="cdj_margin_span"> -->
            <!-- <span><span class="cdj_span">*</span>类型</span>
            <div class="cdj_input" v-if="csa==1">
              <el-select v-model="dades.type" placeholder="请选择类型"  @change="changesa(dades.type)" style="width: 100%;">
                <el-option label="住宅" value="1"></el-option>
                <el-option label="车位" value="2"></el-option>
                <el-option label="储藏室" value="3"></el-option>
                <el-option label="商铺" value="4"></el-option>
              </el-select>
            </div> -->
           <!-- <div class="cdj_input" v-if="csa==2">
              <el-select v-model="dades.type" placeholder="请选择类型"  @change="changesa(dades.type)" style="width: 100%;" disabled>
                <el-option label="住宅" value="1"></el-option>
                <el-option label="车位" value="2"></el-option>
                <el-option label="储藏室" value="3"></el-option>
                <el-option label="商铺" value="4"></el-option>
              </el-select>
            </div>
          </div> -->
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>绑定收费项</span>
            <div class="cdj_input">
              <el-select v-model="dades.charge_id" clearable filterable placeholder="请选择绑定收费项" style="width: 100%;">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="cdj_margin_span">
            <span>备注</span>
            <el-input class="cdj_input"  placeholder="备注" v-model="dades.remarks"></el-input>
          </div>
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>绑定要生成账单的房产</span>
            <div class="cdj_input">
              <el-tree
                :props="datas"
                :data="dataarr"
                lazy
                :load="loadNode"
                show-checkbox
                ref="tree"
                node-key="id"
                includeHalfChecked="false"
                :default-checked-keys="defaultcheckedkeys"
                :default-expanded-keys="defaultcheckedkeyssa">
              </el-tree>
            </div>
          </div>
        </div>
      </el-form>
    </Modal>
    <Modal
      v-model="modal12"
      width="600"
      title="生成订单"
      :loading="loadingModal"
      @on-ok="shengcok">
      <el-form style="height: 600px;overflow: auto;">
        <div class="cdj_margin_span">
          <span><span class="cdj_span">*</span>生成订单</span>
          <div class="cdj_input">
            <el-date-picker
              v-model="yeardata.datevalue"
              type="daterange"
              :unlink-panels="unlinkpanels"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </div>
      </el-form>
    </Modal>
  </div>

</div>

</template>

<script>
import ErpProject from "../Common/erp-project";
export default {
  name: "pindexAllocation",
  components: {ErpProject},
  data () {
    return {
      unlinkpanels:true,
      loadingModal:true,
      dades:{
          id:'',
          name:'',
          pindex_id:'',
          type:'',
          remarks:'',
          charge_id:'',
      },
      options: [],
      datas1:[],
      datas:{
        label: 'label',
        children: 'zones',
        isLeaf: 'leaf',
        value: 'id',
        value1:'region',
        varue2:'type',
        value3:'pindex_id',
      },
      dataarr:[],
      defaultcheckedkeys:[],
      defaultcheckedkeyssa:[],
      cfx:[],
      id:'',
      company_name:'',
      jname:'',
      name:'',
      options2:[],
      value: '',
      value1:'',
      input1: '',
      desserts: '',
      cs:'',
      csa:1,
      total:0,
      page:12,
      search:'',
      anxiu:'保存',
      modal1: false,
      loading:false,
      modal12:false,
      node_had: [], // 触发 tree 的 :load=loadNode 重复触发  动态更新tree
	    resolve_had: [],
      arr:[],
      yeardata:{
        id:'',
        datevalue:[]
      }
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    this.id = this.$route.query.id;
    this.dades.pindex_id = this.id;
    this.company_name = this.$route.query.company_name;
    this.jname = this.$route.query.jname;
    this.name = this.$route.query.name;
    // this.change(1);
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //获得当前多少页,分页
    change(e){
      if(this.id != undefined){
        this.loading = true;
        this.$myhttp.get('admin/allocation?id='+ e + '&search='+ this.search +'&aid='+this.id,{
          'Content-Type': 'application/json'
          }).then(backdata=>{
            this.desserts = backdata.data[0];
            this.total = backdata.data[1];
            this.page = backdata.data[2];
            this.loading = false;
        });
      }
    },
    //搜索
    searchs(){
      this.change(1);
    },
    //保存
    ok(){
       if(this.dades.name == ''){
          this.$Message.error('缴费名称不能为空!');
          this.loadingModals();
          return false;
       }
       if(this.dades.type == ''){
          this.$Message.error('类型不能为空!');
          this.loadingModals();
          return false;
       }
       if(this.dades.charge_id == ''){
          this.$Message.error('请选择绑定收费项!');
          this.loadingModals();
          return false;
       }
       if(this.$refs.tree.getCheckedKeys().length == 0){
          this.$Message.error('绑定不能为空!');
          this.loadingModals();
          return false;
       }
       var id = this.$refs.tree.getCheckedKeys();//获得全选状态id(回显用)
      //  var id = this.$refs.menu.getHalfCheckedKeys().concat(this.$refs.menu.getCheckedKeys())
       var ids = this.$refs.tree.getCheckedNodes();//获得全选状态id数组（保存遍历出住宅用）
       var dade = [id,this.dades,1,ids]
       this.loading = true;
       this.$myhttp.post('admin/allocationAdd',dade,{
       'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{
              this.modal1 = false;
              this.loading=false;
              this.$Message.success("操作成功");
              this.node_had.childNodes = []; //把存起来的node的子节点清空，不然会界面会出现重复树！
              this.loadNode(this.node_had, this.resolve_had); //再次执行懒加载的方法
              this.change(1);
              this.$Loading.finish();
              this.dades.id = '';
              this.dades.name = '';
              this.dades.type = '';
              this.dades.remarks = '';
              this.value = [];
        });
    },
    //绑定收费项,添加
    modals(){
        this.$set(this,'csa',1);
        this.modal1 = true;
        if(this.dades.id){
          this.defaultcheckedkeys=[];
          this.node_had.childNodes = [];
          this.arr = [];
          this.loadNode(this.node_had, this.resolve_had); //再次执行懒加载的方法
          this.dades.id = '';
          this.dades.name = '';
          this.dades.type = '';
          this.dades.remarks = '';
          this.dades.charge_id = '';
          this.datas=[
              {
                id:0,
                label: '请选择类型',
                children:[]
              },
          ];
        }
    },
    //修改收费项
    xiugai(e){
        this.$set(this,'csa',2);
        this.modal1 = true;
        this.loading = true;
        this.$myhttp.get('admin/getAllocationAdd?id='+e,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.dades = backdata.data[0][0];
          this.value = backdata.data[1];
          this.arr = backdata.data[2];
          this.defaultcheckedkeys = [];
          // console.log(this.defaultcheckedkeys)
          // this.$refs.tree.setCheckedKeys([]);
          this.$forceUpdate();
          this.$myhttp.get('admin/getAllocationArr?id='+this.id+"&type="+backdata.data[0][0]['type']+"&name="+this.name,{
          'Content-Type': 'application/json'
          }).then(backdata=>{
            // this.datas = backdata.data[0];
            //this.options =  backdata.data[1];
            this.node_had.childNodes = []; //把存起来的node的子节点清空，不然会界面会出现重复树！
            this.loadNode(this.node_had, this.resolve_had); //再次执行懒加载的方法
            this.loading = false;
          });
        });
    },
    //生成订单
    shengc(e){
      this.modal12 = true;
      this.yeardata.id = e;
    },
    //生成订单提交
    shengcok(){
      if(this.yeardata.datevalue != null && this.yeardata.datevalue[0] != NaN && this.yeardata.datevalue[0] != '' && this.yeardata.datevalue[0] != null){
        var d = this.yeardata.datevalue[0];//开始时间
        var e = this.yeardata.datevalue[1];//结束时间
        this.yeardata.datevalue[0] = new Date(d).getTime()/1000;
        this.yeardata.datevalue[1] = new Date(e).getTime()/1000;
      }else{
        this.$Message.error('请选择生成时间范围!');
        this.loadingModals();
        return false;
      }
      this.$confirm('此操作将生成收费订单, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          this.$myhttp.post('admin/Allocation/orderCharge',this.yeardata,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{
              this.modal12=false;
              this.yeardata.datevalue = [];
              this.loadingModals();
              this.loading = false;
              this.$Message.success('生成订单成功!');
              this.change(1);
          });
        })
    },
    //删除收费项
    del(e){
        this.$confirm('此操作将永久删除该项吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          this.$myhttp.post('admin/allocationDelete',{id:e},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{
              if(backdata.data == 200){
                this.change(1);
                this.$Message.success('删除成功!');
              }
          });
        }).catch(() => {
        });
    },
    //监听
    changesa(e){
      this.node_had.childNodes = []; //把存起来的node的子节点清空，不然会界面会出现重复树！
      this.loadNode(this.node_had, this.resolve_had); //再次执行懒加载的方法
    },
    //绑定
    loadNode(node, resolve) {
        var _this = this;
        setTimeout(() => {
        if (node.level === 0) {
          this.node_had = node;
          this.resolve_had = resolve;
          return resolve([{label:this.name,id:this.id,region:0,type:this.dades.type,pindex_id:this.id,superior:'0'}]);
        }
        this.dades.type = 1;
        if(this.dades.type == ''){
            this.$Message.error('请先选择类型，在来加载绑定!');
            this.node_had.childNodes = []; //把存起来的node的子节点清空，不然会界面会出现重复树！
            this.loadNode(this.node_had, this.resolve_had); //再次执行懒加载的方法
            return false;
        }
          //加载
          if(!node.data.pindex_id){
            node.data = {
              id: node.data.id,
              label: node.data.label,
              pindex_id: node.data.id,
              region: node.data.region,
              type:'1',
              superior: "0"
            }
          }
          _this.defaultcheckedkeys=[]
          this.$myhttp.post('admin/getBindingArrs1',node.data,{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            _this.defaultcheckedkeys =  _this.arr;
            return resolve(backdata.data);
          });
        }, 300);
    },
    //弹窗不要关闭
    loadingModals(){
      let _this = this;
      _this.loadingModal=false;
      setTimeout(() => {
        _this.loadingModal = true;
      }, 10);
    },
    //传参数
    nodeClick(e){
      this.id=e.id;
      this.dades.pindex_id = this.id;
      //查询
      this.$myhttp.get('admin/getOrganizations?pid='+this.id,{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.company_name = backdata.data.data[0].company_name;
        this.jname = backdata.data.data[0].jname;
        this.name=backdata.data.data[0].name;
        this.node_had.childNodes = [];
        this.loadNode(this.node_had, this.resolve_had); //再次执行懒加载的方法
      });
      this.change(1)
    }
  },
  watch: {
    '$route' (to, from) { //监听路由是否变化
      //加载项目
      if(to.path == "/pindex/Allocation"){
        this.id = this.$route.query.id;
        this.dades.pindex_id = this.id;
        this.company_name = this.$route.query.company_name;
        this.jname = this.$route.query.jname;
        this.name = this.$route.query.name;
        //console.log(this.id)
        if(this.id != undefined){
           this.change(1);
        }else{
          this.desserts = [];
          this.total = 0;
          this.page = 0;
        }
        this.dades.type = '';
      }
    },
    'dades.pindex_id'(val){
      if(this.dades.pindex_id){
        let _this = this;
        setTimeout(function(){
            _this.$myhttp.get('admin/getBindingArr1?id='+_this.id+"&name="+_this.name,{
            'Content-Type': 'application/json'
            }).then(backdata=>{
              // _this.dataarr = backdata.data[0];
              _this.options =  backdata.data[1];
              if(_this.dades.id == ""){
                _this.value = [];
                _this.$refs.tree.setCheckedKeys([]);
                _this.$forceUpdate();
              }
              _this.loading = false;
            });
        },200)
      }
    }

  },

}
</script>
<style scoped>
.bangd{
  margin-left: 14%;
  color: rgb(6, 141, 107);
}
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhujie{
  margin-left: 12.7%;
  color: brown;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.el-button{
    color: rgb(252, 247, 247);
}
.item{
  margin-top: 1%;
}
.ys{
  color: brown;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}

 .demo-spin-icon-load{
      animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
      from { transform: rotate(0deg);}
      50%  { transform: rotate(180deg);}
      to   { transform: rotate(360deg);}
  }
  .demo-spin-col{
      height: 100px;
      position: relative;
  }
  .loading{
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90%;
    width: 85%;
  }

</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/Allocation.vue